// extracted by mini-css-extract-plugin
export default {"attrString":"index_attrString__lxETx"};